/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automated_Tax_Collection_AvailInputs */

const en_automated_tax_collection_avail = /** @type {(inputs: Automated_Tax_Collection_AvailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automated tax collection available`)
};

const es_automated_tax_collection_avail = /** @type {(inputs: Automated_Tax_Collection_AvailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recaudación de impuestos automatizada disponible`)
};

const fr_automated_tax_collection_avail = /** @type {(inputs: Automated_Tax_Collection_AvailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collecte automatisée des taxes disponible`)
};

const de_automated_tax_collection_avail = /** @type {(inputs: Automated_Tax_Collection_AvailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisierte Steuererfassung verfügbar`)
};

const ja_automated_tax_collection_avail = /** @type {(inputs: Automated_Tax_Collection_AvailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動税金徴収機能が利用可能`)
};

const zh_automated_tax_collection_avail = /** @type {(inputs: Automated_Tax_Collection_AvailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提供自动化的税务代收服务`)
};

const ar_automated_tax_collection_avail = /** @type {(inputs: Automated_Tax_Collection_AvailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتوفر ميزة تحصيل الضرائب الآلي`)
};

const id_automated_tax_collection_avail = /** @type {(inputs: Automated_Tax_Collection_AvailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penagihan pajak otomatis tersedia`)
};

const it_automated_tax_collection_avail = /** @type {(inputs: Automated_Tax_Collection_AvailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibile la riscossione automatizzata delle tasse`)
};

const ru_automated_tax_collection_avail = /** @type {(inputs: Automated_Tax_Collection_AvailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступен автоматизированный сбор налогов`)
};

const pt_automated_tax_collection_avail = /** @type {(inputs: Automated_Tax_Collection_AvailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coleta automatizada de impostos disponível`)
};

const ko_automated_tax_collection_avail = /** @type {(inputs: Automated_Tax_Collection_AvailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자동 세금 징수 기능 제공`)
};

/**
* | output |
* | --- |
* | "Automated tax collection available" |
*
* @param {Automated_Tax_Collection_AvailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const automated_tax_collection_avail = /** @type {((inputs?: Automated_Tax_Collection_AvailInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automated_Tax_Collection_AvailInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automated_tax_collection_avail(inputs)
	if (locale === "es") return es_automated_tax_collection_avail(inputs)
	if (locale === "fr") return fr_automated_tax_collection_avail(inputs)
	if (locale === "de") return de_automated_tax_collection_avail(inputs)
	if (locale === "ja") return ja_automated_tax_collection_avail(inputs)
	if (locale === "zh") return zh_automated_tax_collection_avail(inputs)
	if (locale === "ar") return ar_automated_tax_collection_avail(inputs)
	if (locale === "id") return id_automated_tax_collection_avail(inputs)
	if (locale === "it") return it_automated_tax_collection_avail(inputs)
	if (locale === "ru") return ru_automated_tax_collection_avail(inputs)
	if (locale === "pt") return pt_automated_tax_collection_avail(inputs)
	return ko_automated_tax_collection_avail(inputs)
});